"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var polished_1 = require("polished");
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var react_1 = tslib_1.__importDefault(require("react"));
var ProviderLogoWrapper = styled_components_1["default"].a(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  flex: 0 0 auto;\n  display: flex;\n  margin: ", ";\n"], ["\n  flex: 0 0 auto;\n  display: flex;\n  margin: ", ";\n"])), function (_a) {
    var _b = _a.margin, margin = _b === void 0 ? "0 " + polished_1.rem(24) + " 0 0" : _b;
    return margin;
});
var LogoAspectRationWRapper = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  width: ", ";\n  padding: 100% 0 0 0;\n"], ["\n  position: relative;\n  width: ", ";\n  padding: 100% 0 0 0;\n"])), function (_a) {
    var size = _a.size;
    return polished_1.rem(size);
});
var LogoPicture = styled_components_1["default"].div(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  flex: 0 0 auto;\n  width: ", ";\n  height: ", ";\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n\n  > img {\n    max-width: ", ";\n    height: auto;\n  }\n  ", " {\n    > img {\n      max-width: ", ";\n      height: auto;\n    }\n  }\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  flex: 0 0 auto;\n  width: ", ";\n  height: ", ";\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n\n  > img {\n    max-width: ", ";\n    height: auto;\n  }\n  ", " {\n    > img {\n      max-width: ", ";\n      height: auto;\n    }\n  }\n"])), function (_a) {
    var size = _a.size;
    return polished_1.rem(size);
}, function (_a) {
    var size = _a.size;
    return polished_1.rem(size);
}, polished_1.rem(11), function (_a) {
    var size = _a.size;
    return polished_1.rem(size);
}, utilities_1.mb('s'), function (_a) {
    var size = _a.size;
    return polished_1.rem(size);
});
var ProviderLogo = function (_a) {
    var provider = _a.provider, margin = _a.margin, _b = _a.size, size = _b === void 0 ? 48 : _b;
    return (react_1["default"].createElement(ProviderLogoWrapper, { margin: margin, href: "/tv-program/tv-stanica/" + provider._id + "/#allDay=0" },
        react_1["default"].createElement(LogoAspectRationWRapper, { size: size }, provider.logo ? (react_1["default"].createElement(LogoPicture, { size: size },
            react_1["default"].createElement("img", { src: provider.logo.src, alt: provider.logo.alt, title: provider.name }))) : (react_1["default"].createElement(LogoPicture, { size: size },
            react_1["default"].createElement("span", null, provider._id))))));
};
exports["default"] = ProviderLogo;
var templateObject_1, templateObject_2, templateObject_3;
